import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditGeoFences',
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule() {
      return [v => !!v || parseInt(v) === 0 || this.$i18n_t('Common.fieldRequired')];
    },
    distanceRules() {
      return [v => !!v && (isNaN(parseFloat(v)) || parseFloat(v) <= 0 ? this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule') : true) || this.$i18n_t('Common.fieldRequired')];
    },
    hourRules() {
      return [v => !!v && (isNaN(parseFloat(v)) || parseFloat(v) <= 0 ? this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule') : true) || this.$i18n_t('Common.fieldRequired')];
    },
    geoFences() {
      return get(this.rule, 'properties.geoFences') || [];
    }
  },
  watch: {},
  methods: {
    geoFenceFilter(twin) {
      return ['zone', 'floor', 'building'].indexOf((twin.data.type || '').toLowerCase()) >= 0 && twin.hasPolygon;
    }
  }
};